import { LoginCallback } from '@okta/okta-react';
import { EnterNewPassword } from '@tcs/client-portal/pages/EnterNewPassword';
import Login from '@tcs/client-portal/pages/Login';
import ResetPassword from '@tcs/client-portal/pages/ResetPassword';
import Spinner from '@tcs/common/components/atoms/Spinner';
import { FundingRequestCompleted } from '@tcs/fund-account/pages/FundingRequestCompleted';
import { useEffect } from 'react';
import { Route, Routes, useNavigate } from 'react-router-dom';
import addPolyfills from './assets/polyfills';
import { RequiredAuth } from './SecureRoute';

const App = () => {
  const nav = useNavigate();

  useEffect(() => {
    addPolyfills();
  }, []);

  const onAuthRequired = () => {
    nav('/login');
  };

  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        path="/login/callback"
        element={
          <LoginCallback
            loadingElement={<Spinner />}
            onAuthResume={onAuthRequired}
          />
        }
      />

      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/new-password" element={<EnterNewPassword />} />
      {/* Public route to allow redirect for non authenticated users */}
      <Route
        path="/funding-request-completed"
        element={<FundingRequestCompleted />}
      />
      <Route path="*" element={<RequiredAuth />} />
    </Routes>
  );
};

export default App;
